import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import App from './App';
import './index.css';

const container = document.getElementById('root');
if (!container) throw new Error('root element not found');

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <App />
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            background: '#0F172A',
            color: '#fff',
            fontWeight: 500,
            borderRadius: 8,
            padding: '12px 16px',
            fontFamily: "'IBM Plex Sans', sans-serif",
          },
        }}
      />
    </BrowserRouter>
  </StrictMode>
);
